import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="container">
      <h1>Privacy Policy</h1>
      
      <p>
        At <span className="bold">Albums and Art</span>, we value your privacy and are committed to protecting your personal information. This Privacy Policy outlines how we collect, use, and safeguard the information you provide to us.
      </p>
      
      <h2>Information Collection and Use</h2>
      
      <h3>1. Information We Collect</h3>
      <p>
        When you make a purchase or interact with us, we may collect personal information such as your name, email address, phone number, and shipping address.
      </p>
      
      <h3>2. Purpose of Information Use</h3>
      <p>The information you provide will be used solely for the following purposes:</p>
      <ul>
        <li><strong>Marketing:</strong> To send you updates, promotions, and relevant information about our products and services.</li>
        <li><strong>Sales:</strong> To process your orders and manage your transactions effectively.</li>
        <li><strong>Customer Service:</strong> To respond to your inquiries, provide support, and enhance your overall experience with us.</li>
      </ul>
      
      <h2>Information Sharing</h2>
      
      <h3>3. No Sale of Personal Information</h3>
      <p>
        We are committed to your privacy and will never sell your personal information to any third party for marketing purposes. Your information is safe with us, and we will only share it as necessary to fulfill your orders or comply with legal obligations.
      </p>
      
      <h2>Data Security</h2>
      
      <h3>4. Protection of Your Information</h3>
      <p>
        We implement a variety of security measures to maintain the safety of your personal information. These measures include encryption, secure servers, and regular security assessments to protect against unauthorized access.
      </p>
      
      <h2>Your Rights</h2>
      
      <h3>5. Accessing and Updating Your Information</h3>
      <p>
        You have the right to access the personal information we hold about you and to request corrections if necessary. To do this, please contact our customer service team at <span className="bold">info@albumsandart.com</span> with your request.
      </p>
      
      <h3>6. Opting Out of Marketing Communications</h3>
      <p>
        If you wish to opt out of receiving marketing communications from us, you can do so by following the unsubscribe instructions found in our emails or by contacting us directly.
      </p>
      
      <h2>Changes to This Privacy Policy</h2>
      
      <h3>7. Policy Updates</h3>
      <p>
        We may update this Privacy Policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. We encourage you to review this policy periodically for the latest information on our privacy practices.
      </p>
      
      <h2>Contact Us</h2>
      
      <h3>8. Questions or Concerns</h3>
      <p>
        If you have any questions or concerns about this Privacy Policy or how we handle your information, please do not hesitate to reach out to us at <span className="bold">info@albumsandart.com</span>. We are here to assist you.
      </p>
      
      <p>
        Thank you for trusting <span className="bold">Albums and Art</span> with your information. We are dedicated to ensuring your privacy and providing you with a safe and enjoyable experience.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
